import {
    CopyIcon,
    EnvelopeClosedIcon
} from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from '../ui/use-toast';

const EmailAllDialog = ({ members }) => {
    const [emailList, setEmailList] = useState('');
    const [includeSuspended, setIncludeSuspended] = useState(false);
    const [includeExpired, setIncludeExpired] = useState(false);
    const [includeParents, setIncludeParents] = useState(true);

    const getEmailList = () => {
        let emailList = '';

        members.forEach((member) => {
            const isExpired = !member.minimember && new Date(member.membership_expiration) < new Date();
            const isSuspended = !!member.suspended_at;

            // Skip if email ends with @redacted.com
            const isRedactedEmail = member.email.endsWith('@redacted.com');
            const isRedactedParentEmail = member.parent_email?.endsWith('@redacted.com');

            if (
                !isRedactedEmail &&
                (includeSuspended || !isSuspended) &&
                (includeExpired || !isExpired)
            ) {
                emailList += member.email + ', ';

                if (includeParents && member.parent_email && !isRedactedParentEmail) {
                    emailList += member.parent_email + ', ';
                }
            }
        });

        // Remove duplicate emails
        emailList = emailList
            .split(',')
            .map(email => email.trim())
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ');

        setEmailList(emailList);
    };

    useEffect(() => {
        getEmailList();
    }, [members, includeSuspended, includeExpired, includeParents]);

    return (
        <Dialog>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <EnvelopeClosedIcon className='mr-3'/>
                    Hämta e-postlista
                </DialogTrigger>
                <DialogContent className="flex flex-col gap-6" onOpenAutoFocus={(e) => e.preventDefault()}>
                    <DialogHeader className='text-left'>
                        <DialogTitle>Hämta e-postlista</DialogTitle>
                        <DialogDescription>
                            Anpassa listan genom att välja vilka typer av medlemmar som ska inkluderas.
                        </DialogDescription>
                    </DialogHeader>

                    <div className="flex flex-col gap-3">
                        <Label className="flex items-center gap-2">
                            <Checkbox
                                checked={includeSuspended}
                                onCheckedChange={() => setIncludeSuspended(!includeSuspended)}
                            />
                            Inkludera avstängda användare
                        </Label>
                        <Label className="flex items-center gap-2">
                            <Checkbox
                                checked={includeExpired}
                                onCheckedChange={() => setIncludeExpired(!includeExpired)}
                            />
                            Inkludera användare med utgångna medlemskap
                        </Label>
                        <Label className="flex items-center gap-2">
                            <Checkbox
                                checked={includeParents}
                                onCheckedChange={() => setIncludeParents(!includeParents)}
                            />
                            Inkludera föräldrars e-postadresser
                        </Label>
                    </div>

                    <Textarea
                        readOnly={true}
                        value={emailList}
                    />

                    <div className='grid grid-cols-2 gap-3'>
                        <DialogClose asChild>
                            <Button type='button' variant='secondary'>Stäng</Button>
                        </DialogClose>
                        <Button
                            type="button"
                            onClick={() => {
                                navigator.clipboard.writeText(emailList);
                                toast({
                                    title: 'E-postadresserna är kopierade',
                                    description: ''
                                });
                            }}
                        >
                            <CopyIcon className="size-4 mr-3" />
                            Kopiera
                        </Button>
                    </div>
                </DialogContent>
            </DropdownMenuItem>
        </Dialog>
    );
};

export default EmailAllDialog;
